<!-- 第三方登录注册用户  -->
<template>
  <el-dialog :visible.sync="visibled" width="400px" :before-close="beforeClose">
    <el-form label-position="top" label-width="80px" ref="userForm" :model="userForm" :rules="rules">
      <el-form-item :label="$t('Home.Components.ThirdPartyRegistration.FullName')" prop="fullName">
        <el-input v-model.trim="userForm.fullName"></el-input>
      </el-form-item>
      <el-form-item :label=" $t('Home.Components.ThirdPartyRegistration.EmailID')" prop="email">
        <el-input v-model.trim="userForm.email" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('Home.Components.ThirdPartyRegistration.Password')" prop="password">
        <el-input type="password" v-model.trim="userForm.password" show-password autocomplete="new-password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="register-but" type="primary" @click="register">{{ $t('Home.Components.ThirdPartyRegistration.RegisterForFree') }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { randomString } from '@/util/random.js'
import { encrypt } from '@/util/encryp.js'

export default {
  data() {
    return {
      visibled: false,
      userForm: {
        fullName: '',
        email: '',
        password: '',
        loginThirdType: 1,
        loginThirdkey: ''
      },
      rules: {
        password: [
          { required: true, message: `${this.$t('Home.Components.ThirdPartyRegistration.Tips1')}`, trigger: 'blur' },
          { min: 6, max: 20, trigger: 'blur', message: `${this.$t('Home.Components.ThirdPartyRegistration.Tips2')}` }
        ]
      }
    }
  },
  methods: {
    show(userForm) {
      this.visibled = true
      Object.assign(this.userForm, userForm)
      this.userForm.password = randomString(8)
    },
    beforeClose() {
      this.visibled = false
    },
    register() {
      this.$refs.userForm.validate(valid => {
        if (!valid) return
        let form = {
          ...this.userForm
        }
        form.password = encrypt(form.password)
        form.referrer = localStorage.getItem('referrer') || undefined
        form.equipment = this.$store.state.isPC ? 'pc' : 'mobile'
        // 如果用户是平台引流进入kakaclo，注册的时候带上推广码,来源
        if (this.$store.state.common.promotionCode) {
          form.inviteCode = this.$store.state.common.promotionCode
          form.userSource = this.$store.state.common.promotionSource
        }
        API.logoutSignUp(form)
          .then(result => {
            this.$message.success(this.$t('promptText.msg32'))
            this.beforeClose()
            this.$emit('registerSuccess')
          })
          .catch(result => {
            this.$message.error(result.data.message)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.register-but{
  margin-top: 20px;
  width: 100%;
  border-radius: 100px;
}
</style>
